import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Solutionfsk() {
  return (
    <div className="solution_fsk p-100">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={5} xl={6} xxl={6} className="resp_order">
            <div className="sol_fsk_img_1">
              <StaticImage
                src="../../../images/case-studies/fsk/sol-img.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["png"]}
                width={749}
                height={847}
              />
            </div>
          </Col>
          <Col xs={12} md={6} lg={5} xl={4} xxl={4} className="my-auto">
            <div className="sol_fsk_content">
              <h2>
                Solutions <span>Delivered</span>
              </h2>
              <p>
                Harmoniously integrated match-3 puzzles, time management
                challenges, and role-playing elements, creating a cohesive and
                immersive gaming experience.
              </p>
              <p>
                Implemented non-intrusive monetization strategies, ensuring that
                in-app purchases and ads enhance the player experience rather
                than disrupt the flow of the game.
              </p>
              <p>
                Successfully woven a compelling narrative into the gameplay,
                elevating the story tellingaspect and providing players with a
                deeper connection to the in-game world.
              </p>
              <p>
                Designed puzzles that adapt dynamically, offering continuous
                challenges aligned with thee volving narrative, contributing to
                sustained player engagement.
              </p>
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={2}
            xl={2}
            xxl={2}
            className="my-auto resp_order_1"
          >
            <div className="sol_fsk_img">
              <StaticImage
                src="../../../images/case-studies/fsk/sol-img-right.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["png"]}
                width={183}
                height={500}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Solutionfsk;
